export class Renderer {
    _templates;
    constructor(_templates) {
        this._templates = _templates;
    }
    __render(parent, template, data) {
        const tpl = document.createElement('template');
        tpl.innerHTML = this._templates[template]?.(data || {});
        const content = tpl.content;
        const firstElement = content.firstElementChild;
        parent.appendChild(content);
        return firstElement instanceof HTMLElement ? firstElement : null;
    }
}
//# sourceMappingURL=render.js.map